export class PageCursor {
    backing;
    constructor(backing) {
        this.backing = backing;
    }
}
//# sourceMappingURL=pagination.js.map